export const PLUS_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
  <path d="M12 8H19C19.5523 8 20 8.44771 20 9V11C20 11.5523 19.5523 12 19 12H12V19C12 19.5523 11.5523 20 11 20H9C8.44771 20 8 19.5523 8 19V12H1C0.447715 12 0 11.5523 0 11V9C0 8.44771 0.447715 8 1 8H8V1C8 0.447715 8.44771 0 9 0H11C11.5523 0 12 0.447715 12 1V8Z" fill="currentColor"/>
</svg>`;
